<template>
  <v-layout row justify-center>
    <v-dialog v-model="userNewTicket" max-width="630px"
      transition="dialog-bottom-transition" @keydown.esc="userNewTicket = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">NOVO TICKET</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="userNewTicket = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Assunto" v-model="ticket.subject" outline required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="ticket.message" label="Mensagem" outline
                  rows="6" auto-grow required></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="create()" round large depressed color="success" :loading="loadingRequest">
            Enviar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
const currentUser = JSON.parse(localStorage.getItem('currentUser'))

export default {
  data: () => ({
    userNewTicket: false,
    loadingRequest: false,
    ticket: {
      subject: '',
      message: ''
    },
    adminNotification: {
      user: 'fa04fc40-6f12-4b22-9875-d447c0963fc4', // admin ID
      all_users: false,
      title: 'Novo ticket aberto',
      // eslint-disable-next-line
      url: `${API.siteURL}/support`
    }
  }),

  methods: {
    create () {
      this.loadingRequest = true

      // eslint-disable-next-line
      axios.post(`${API.userTickets}/users/${currentUser._id}`, this.ticket).then(response => {
        this.userNewTicket = false
        EventBus.$emit('loadTickets')
        this.notifyAdmin()
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao criar o ticket',
          color: 'error'
        })
      })
    },

    notifyAdmin () {
      // eslint-disable-next-line
      axios.post(`${API.notifications}/users`, this.adminNotification)
    }
  },

  beforeDestroy () {
    EventBus.$off('userNewTicket')
  },

  mounted () {
    EventBus.$on('userNewTicket', data => {
      this.userNewTicket = data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/support/UserNewTicket.vue